
import { ItemDatabase } from "@/state/Gacha";
import { Item, ItemStringQuantity, ShopItem } from "@/types";
import { defineComponent } from "vue";
import CancelConfirmButton from "@/components/shared/CancelConfirmButton.vue";
import ItemDescriptionOverlay from "./ItemDescriptionOverlay.vue";
import ItemObtainOverlay from "./ItemObtainOverlay.vue";
import GemCounter from "@/components/shared/GemCounter.vue";
import Inventory from "@/state/Inventory";

export default defineComponent({
  components: {
    CancelConfirmButton,
    ItemDescriptionOverlay,
    GemCounter,
    ItemObtainOverlay,
  },
  props: {
    shopItem: {
      type: Object as () => ShopItem,
      required: true,
    },
    inventory: {
      type: Object as () => Inventory,
      required: true,
    },
  },
  emits: ["exit"],
  data() {
    return {
      active: true,
      activeItemId: "",
      quantityToPurchase: 1,
      purchasedItemId: "",
      bodyBoxBgColours: [
        [],
        ["#505865", "#545a66", "#828e99"],
        ["#46565c", "#485d60", "#659973"],
        ["#525376", "#4e5d7c", "#489fb3"],
        ["#595482", "#716196", "#b684c8"],
        ["#695352", "#99694e", "#e3ad52"],
      ],
    };
  },
  computed: {
    cssBox(): { [name: string]: string } {
      return {
        "--body-bg-gradient-start": this.bodyBoxBgColours[this.item.rarity][0],
        "--body-bg-gradient-middle": this.bodyBoxBgColours[this.item.rarity][1],
        "--body-bg-gradient-end": this.bodyBoxBgColours[this.item.rarity][2],
      };
    },
    activeItem(): Item {
      return ItemDatabase[this.activeItemId];
    },
    purchasedItem(): ItemStringQuantity[] {
      return [{ id: this.purchasedItemId, quantity: this.quantityToPurchase }];
    },
    item(): Item {
      return ItemDatabase[this.shopItem.id];
    },
    numPurchasable(): number {
      let bank = -1;
      switch (this.shopItem.cost[0].id) {
        case "primogem":
          bank = this.inventory.primos;
          break;
        case "intertwined-fate":
          bank = this.inventory.fates;
          break;
        case "stardust":
          bank = this.inventory.stardust;
          break;
        case "starglitter":
          bank = this.inventory.starglitter;
          break;
      }
      return Math.floor(bank / this.shopItem.cost[0].quantity);
    },
    insufficientFunds(): boolean {
      return this.numPurchasable > 0 ? false : true;
    },
  },
  methods: {
    purchase() {
      this.inventory.addItems([
        { id: this.item.id, quantity: this.quantityToPurchase },
      ]);
      this.inventory.removeItems([
        {
          id: this.shopItem.cost[0].id,
          quantity: this.shopItem.cost[0].quantity * this.quantityToPurchase,
        },
      ]);
      this.purchasedItemId = this.item.id;
    },
    setQuantityToPurchase(quantity: number) {
      this.quantityToPurchase = Math.min(
        this.numPurchasable,
        Math.max(quantity, 1)
      );
    },
    exitOutsideCheck(e: Event) {
      if (e.target === document.getElementById("item-purchase-overlay-bg")) {
        (this.$refs.audioDescriptionOverlayExit as HTMLAudioElement).play();
        this.active = false;
      }
    },
    exit() {
      if (!this.active) {
        this.$emit("exit");
      }
    },
  },
});
